import React from 'react';
import { makeBookStyles } from 'styles/pages/book';
import { Box, Typography } from '@material-ui/core';

type Props = { author?: string; MEN: string; title: string };

const MainDataPanel: React.FC<Props> = ({ author, MEN, title }) => {
    const { paragraph } = makeBookStyles();

    return (
        <>
            <Box marginBottom={2}>
                <Typography
                    component="h2"
                    variant="h5"
                    dangerouslySetInnerHTML={{
                        __html: title,
                    }}
                />
            </Box>
            <Box marginBottom={3}>
                <Typography className={paragraph}>{author}</Typography>
                {MEN ? (
                    <Typography className={paragraph}>
                        <b>nr w wykazie MEN:</b> {MEN}
                    </Typography>
                ) : null}
            </Box>
        </>
    );
};

export default MainDataPanel;
